'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = require('./actions');

var initialState = {
    data: null,
    scene: null
};

var reducer = exports.reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _actions.SET_COMPLETED_WORKFORM:
            {
                return _extends({}, state, { data: action.payload.data });
            }
        case _actions.SET_CORRECT_SCENE:
            {
                return _extends({}, state, { scene: action.payload.scene });
            }
        default:
            return state;
    }
};

exports.default = reducer;